import React from 'react';
import { Box, Typography, Avatar, Container, Grid, Button } from '@mui/material';
import { styled, keyframes } from '@mui/system';
import { developers } from '../../Home/constants/developers';
import companyLogo from '../../../assets/Linkway/LinkwayLogoText2.png';
import { useNavigate } from 'react-router-dom';

const creditsRoll = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(-100%);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const logoZoom = keyframes`
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
`;

const StyledBox = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #fff, #EEF5FF)',
  color: '#fff',
  height: '100vh',
  width: '100vw',
  overflow: 'hidden',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
}));

const CreditsContainer = styled(Container)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: '100%',
  animation: `${creditsRoll} 60s linear infinite`,
}));

const StyledImg = styled('img')(({ theme }) => ({
  width: '250px',
  marginBottom: '20px',
  animation: `${logoZoom} 2s ease-in-out`,
  borderRadius: '50%',
  boxShadow: '0 0 15px rgba(0,0,0,0.3)',
}));

const AnimatedTypography = styled(Typography)(({ theme }) => ({
  '&.MuiTypography-h2, &.MuiTypography-h4, &.MuiTypography-h6, &.MuiTypography-body1': {
    animation: `${fadeIn} 1.5s ease-in-out`,
    marginBottom: '10px',
    color: 'black',
    fontWeight: 500,
  },
}));

const DeveloperBox = styled(Box)(({ theme }) => ({
  marginBottom: '30px',
  // background: '#fff',
  // borderRadius: '20px',
  padding: '20px',
  // border: '1px solid lightgrey',
}));

const Linkway = () => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/home/feedback');
  };
  return (
    <StyledBox>
      <Button id='backToHome' sx={{ position: 'absolute', zIndex: -100 }} onClick={handleNavigate} />
      <CreditsContainer>
        <Box sx={{ py: 2 }}>
          <img src={companyLogo} alt='Company Logo' width={'90%'} />
          <AnimatedTypography variant='h4' gutterBottom>
            CREDITS
          </AnimatedTypography>
        </Box>

        <AnimatedTypography variant='h4' gutterBottom>
          Developers
        </AnimatedTypography>

        {developers.map(developer => (
          <DeveloperBox key={developer.id}>
            <Grid container alignItems='center' justifyContent='center'>
              <Grid item xs={12} sm={2}>
                <Avatar src={developer.avatar} alt={developer.name} sx={{ width: 100, height: 100, mx: 'auto' }} />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Box sx={{ textAlign: 'left' }}>
                  <AnimatedTypography variant='h6'>{developer.name}</AnimatedTypography>
                  <AnimatedTypography variant='body1'>"{developer.quote}"</AnimatedTypography>
                </Box>
              </Grid>
            </Grid>
          </DeveloperBox>
        ))}

        <AnimatedTypography variant='h6' gutterBottom sx={{ mt: 5 }}>
          © 2024 Gateway Group. All rights reserved.
        </AnimatedTypography>
      </CreditsContainer>
    </StyledBox>
  );
};

export default Linkway;
